var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAtmDollarFilled = function SvgAtmDollarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    fillRule: "evenodd",
    d: "M2 5.6A1.6 1.6 0 0 1 3.6 4h16a1.6 1.6 0 0 1 1.6 1.6v12c0 .879-.705 1.6-1.594 1.6H3.596A1.597 1.597 0 0 1 2 17.6v-12Zm9 1V8H9.7a.7.7 0 0 0-.7.7v2.8a.7.7 0 0 0 .7.7H13V14H8.998v1.2H11v1.4h1.2v-1.4h1.3a.7.7 0 0 0 .7-.7v-2.8a.7.7 0 0 0-.7-.7h-3.3V9.2h4.005V8H12.2V6.6H11Z",
    clipRule: "evenodd"
  })));
};
export default SvgAtmDollarFilled;